export default {
  name: 'expand-cell',
  props: {
    expand: Function,
    item: Object
  },
  render(h) {
    return this.expand(this.item);
  }
};
